import { fetchData } from '../../../helpers/base_data_fetcher';

const amenitiesList = document.getElementById('coLivingList');
const button = document.getElementById('coLivingButton');
const listItems = amenitiesList?.querySelectorAll('li');

function toggleAmenitiesListHeight(localisations) {
  let listExtended = false;
  const fullHeight = amenitiesList.getBoundingClientRect().height;
  const itemHeight = amenitiesList.querySelector('li').getBoundingClientRect()
    .height;
  const croppedHeight = itemHeight * 4;
  const buttonText = button.innerText;

  amenitiesList.style.height = `${croppedHeight}px`;

  button.addEventListener('click', () => {
    amenitiesList.style.height = listExtended
      ? `${croppedHeight}px`
      : `${fullHeight}px`;
    listExtended = !listExtended;
    button.innerText = listExtended ? localisations.show_less : buttonText;
  });
}

function init() {
  if (amenitiesList && !listItems.length) {
    document
      .getElementById('coLivingAmenities')
      .classList.add('co-living-amenities--hidden');
    return;
  }

  if (amenitiesList && button) {
    if (listItems.length <= 4) {
      button.style.display = 'none';
      return;
    }

    fetchData('page').then((pageData) => {
      toggleAmenitiesListHeight(pageData.localisations);
    });
  }
}

export default init;
